export default __webpack_public_path__ + "static/media/11-T-Mobile-Logo-2.204dfd33.jpg";